export default __webpack_public_path__ + "static/media/Graphik-Medium-Web.87f53f32.woff";